import { SortOrder } from "primereact/api";
import { createUserSettingsSlice } from "./userSettings";

export interface UsersListFilters {
	searchFilter: string;
	districtFilter: number;
	schoolFilter: number;
	roleFilter: string;
	includeInactive: boolean;
	sortField: string;
	sortOrder: SortOrder;
	page: number;
}

const initialValues: UsersListFilters = {
	searchFilter: "",
	districtFilter: 0,
	schoolFilter: 0,
	roleFilter: "",
	includeInactive: false,
	sortField: "userName",
	sortOrder: 1,
	page: 0,
};

// Transient page state: worth remembering while the user moves around the site,
// not worth remembering after they sign out. Per-user ownership and clearing come
// from the shared model - see userSettings.ts.
//
// The paging reset and the district -> school cascade for this page currently
// live in UsersList.tsx. They could be declared here as `dependents` instead;
// left where they are for now so this change does not alter behaviour.
export const usersListFilterSettings = createUserSettingsSlice<UsersListFilters>({
	name: "usersListFilter",
	initialValues,
	storage: "session",
});

export const { set: setUsersListFilters, reset: resetUsersListFilters } = usersListFilterSettings;

export default usersListFilterSettings.reducer;
